import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'
import Header from '../inc/Header';

import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import rakhibandhan2025 from "../images/Raksha Bandhan 2025.mp4";
import rakhibandhan from "../images/Rakhi Bandhan.mp4";
import tarurakhibandhan from "../images/Taru Rakhi Bandhan.mp4";






function RakhiBandhan2025() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(258);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [programs, setPrograms] = useState([])
    const navigate = useNavigate()

    const programsCollectionRef = collection(db, "Taru Rakhi Bandhan Program 2025");
    useEffect(() => {

        const getPrograms = async () => {
            const data = await getDocs(programsCollectionRef);
            setPrograms(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getPrograms()
    }, [])
    return (

        <>
            <Header />
            <br />
            <br />

            <br />
            <br />


    


            <div className='bestberhamporeschoolmis'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/Gallery" style={{ color: "darkblue" }} >Back</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Taru Rakhi Bandhan Programme 2025

                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
              <div className="album py-1">
        <div className="container">
          <div className="row ">
             <div className="col-md-4 mt-2">

              <Video Play loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={rakhibandhan2025} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-4 mt-2">

              <Video Play loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={rakhibandhan} type="video/webm" />
              </Video>
            </div>

            <div className="col-md-4 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={tarurakhibandhan} type="video/webm" />
              </Video>
            </div>

          </div>
        </div>
      </div>
            <div className="album py-0">

                <div className="container">

                    <div className="row">
                        {programs.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((misaa) => {
                            return (
                                <div className="col-md-4 mt-3" >
                                    <div className='card'>
                                        <div className='hoverimage1'>
                                            <img className="card-img-top image2" src={misaa.img} alt={misaa.title} />
                                            <div className="overlay1"> {misaa.title}</div>
                                        </div>
                                        <div className="card-body">
                                            <center>
                                                <h6 className="mt-" style={{color:"darkBlue"}}> {misaa.title}</h6>
                                            </center>
                                            <div className="d-flex justify-content-between align-items-center">
                                            </div>
                                        </div>

</div>
                                    </div>
                                    )
                        })}
                                </div>


                </div>
                </div>
                <br />

                <br />

            </>

            );
}

            export default RakhiBandhan2025;



